import { render, staticRenderFns } from "./createBusinessDialog.vue?vue&type=template&id=703880f0&scoped=true"
import script from "./createBusinessDialog.vue?vue&type=script&lang=js"
export * from "./createBusinessDialog.vue?vue&type=script&lang=js"
import style0 from "./createBusinessDialog.vue?vue&type=style&index=0&id=703880f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703880f0",
  null
  
)

export default component.exports